// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { haqqTestedge2 as _haqqTestedge2 } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the haqqTestedge2 chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 54211
 * Chain Name: HAQQ Testedge 2
 * Default Block Explorer: https://explorer.testedge2.haqq.network
 * Default RPC URL: https://rpc.eth.testedge2.haqq.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { haqqTestedge2 } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: haqqTestedge2,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const haqqTestedge2 = createCommon({
	..._haqqTestedge2,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
